import { m } from 'framer-motion';
import PropTypes from 'prop-types';
// @mui
import Typography from '@mui/material/Typography';
// layouts
import CompactLayout from 'src/layouts/compact';
// assets
import { SeverErrorIllustration } from 'src/assets/illustrations';
// components
import { MotionContainer, varBounce } from 'src/components/animate';

// ----------------------------------------------------------------------

export default function ErrorView({ error }) {
  const getErrorMessage = () => {
    if (typeof error === 'string') return error;
    if (error?.data?.message) {
      const msg = error.data.message;
      if (Array.isArray(msg)) return msg.join(', ');
      return error?.status === 401 ? 'Session expired' : String(msg);
    }
    if (error?.error) return typeof error.error === 'string' ? error.error : 'Something went wrong';
    if (error?.message) return String(error.message);
    return 'Something went wrong';
  };

  const getSubMessage = () => {
    if (error?.status === 401) {
      return 'Please login again';
    }
    return 'Please try again later or contact the team';
  };

  return (
    <CompactLayout requiredLogo={false}>
      <MotionContainer>
        <m.div variants={varBounce().in}>
          <Typography variant="h3" sx={{ mb: 2 }}>
            {getErrorMessage()}
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography sx={{ color: 'text.secondary' }}>
            {getSubMessage()}
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <SeverErrorIllustration sx={{ height: 260, my: { xs: 5, sm: 10 } }} />
        </m.div>
      </MotionContainer>
    </CompactLayout>
  );
}

ErrorView.propTypes = {
  error: PropTypes.any,
  showTryAgain: PropTypes.bool,
};
